import React, { useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Button,
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Modal,
  TextField
} from '@material-ui/core';

import { addVendorExpectedExpense } from 'redux/actions';
import { months } from 'constants/months';

const ExpectedExpenseModal = (props) => {

  const [values, setValues] = useState({
    total: "",
    month: "0",
    year: moment().year().toString()
  });
  
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const expenseInfo = {
      id: props.vendorId,
      expectedExpense: {
        monthYear: new Date(values.year, values.month),
        total: values.total
      }
    };
    
    props.addVendorExpectedExpense(expenseInfo);
    props.closeModal();
  };

  return (
    <Modal open={props.open}>
      <form
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <Card>
          <CardHeader
            subheader="Add the Expected Expense of Any Month and Year"
            title="Expected Expense"
          />
          <Divider />
          <CardContent>
            <Grid
              container
              spacing={3}
            >
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please select the Expense Month"
                  label="Select Month"
                  name="month"
                  onChange={handleChange}
                  select
                  SelectProps={{ native: true }}
                  value={values.month}
                  variant="outlined"
                >
                  {months.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                    >
                      {option.label}
                    </option>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please specify the Year"
                  label="Year"
                  name="year"
                  onChange={handleChange}
                  required
                  value={values.year}
                  variant="outlined"
                />
              </Grid>
              <Grid
                item
                md={6}
                xs={12}
              >
                <TextField
                  fullWidth
                  helperText="Please specify the Expense Amount"
                  label="Amount"
                  onChange={(event) => setValues({ ...values, total: parseFloat(event.target.value) || 0 })}
                  required
                  value={values.total}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </CardContent>
          <Divider />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              p: 2
            }}
          >
            <Button
              color="primary"
              variant="contained"
              type="submit"
            >
              Save Expense
            </Button>
            <Button sx={{ mx: 1 }} onClick={props.closeModal}>
              Cancel
            </Button>
          </Box>
        </Card>
      </form>
    </Modal>
  )
};

export default connect (null, {addVendorExpectedExpense}) (ExpectedExpenseModal);